/* eslint-disable @typescript-eslint/ban-ts-comment */
import { store } from '@/store';
import { BaseCompoundFormFieldBuilder } from '.';
import { CheckboxGroupFormField, FormFieldType, GridSize } from '../typings';
import { setConditionalParentFields } from '../store';

export class CheckboxGroupFormFieldBuilder extends BaseCompoundFormFieldBuilder<CheckboxGroupFormField> {
  protected _type = FormFieldType.CheckboxGroup;
  protected _typeValue = FormFieldType.CheckboxGroup;
  // @ts-ignore
  private _fields: CheckboxGroupFormField['fields'] = [];
  // @ts-ignore
  private _choices: CheckboxGroupFormField['choices'] = {};
  // @ts-ignore
  private _size?: CheckboxGroupFormField['size'];
  // @ts-ignore
  private _isSingleChoice: CheckboxGroupFormField['isSingleChoice'] = false;
  // @ts-ignore
  private _scale?: CheckboxGroupFormField['scale'];
  // @ts-ignore
  private _label: CheckboxGroupFormField['label'] = 'Label not defined';
  // @ts-ignore
  private _value: CheckboxGroupFormField['value'];

  constructor() {
    super();
  }

  // TODO: Add method to add single field
  public fields(value: CheckboxGroupFormField['fields']): this {
    this._fields = [...value];

    const childrenIds: string[] = [];
    this._fields.forEach(child => {
      childrenIds.push(child.fieldId);
      this._choices[child.fieldId] = false;
    });

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );

    return this;
  }

  public size(value: GridSize): this {
    this._size = { md: value };
    return this;
  }

  public singleChoice(value: boolean): this {
    this._isSingleChoice = value;
    return this;
  }

  public scale(value: CheckboxGroupFormField['scale']): this {
    this._scale = value;
    return this;
  }

  public label(value: CheckboxGroupFormField['label']): this {
    this._label = value;
    return this;
  }

  public value(value: CheckboxGroupFormField['value']): this {
    this._value = value;

    if (value === '') return this;

    value?.split(',').forEach(fieldId => {
      this._choices[fieldId] = true;
    });

    return this;
  }
}
